<template>
  <div class="accountSetting pl-xl-4">
    <div class="border-bottom pb-3 mb-4">
      <h3 class="medium">Documents</h3>
      <div class="p-1 alert-danger d-flex justify-content-center p-2" role="alert" v-if="parseInt(get_user.lead_type) == 1 && parseInt(profileInfo.step) < 5 && finalDocuments && parseInt(finalDocuments.length) < 8">
        <div v-if="parseInt(profileInfo.step) <= 3">
          <span class="mb-0 mr-2">Please upload required documents </span>
          <router-link :to="'/corporate-step' + (parseInt(profileInfo.step) + 1)" class="f-14 cap_btn small">Go to Registration</router-link>
        </div>
        <div v-else-if="parseInt(profileInfo.step) == 4 && profileInfo.documents && profileInfo.documents[0]">
          <span class="mb-0 mr-2">Please upload required documents </span>
          <router-link :to="{path:'/view',query:{id:profileInfo.documents[0].ticket_id}}" class="f-14 cap_btn small">Go to Ticket</router-link>
        </div>
      </div>
      <div class="p-1 alert-danger d-flex justify-content-center" role="alert" v-if="parseInt(get_user.lead_type) == 0 && parseInt(profileInfo.step) < 4 && finalDocuments && parseInt(finalDocuments.length) < 3">
        <div v-if="parseInt(profileInfo.step) <= 2">
          <span class="mb-0 mr-2">Please upload required documents </span>
          <router-link :to="'/individual-step' + (parseInt(profileInfo.step) + 1)" class="f-14 cap_btn small">Go to Registration</router-link>
        </div>
        <div v-else-if="parseInt(profileInfo.step) == 3 && profileInfo.documents && profileInfo.documents[0]">
          <span class="mb-0 mr-2">Please upload required documents </span>
          <router-link :to="{path:'/view',query:{id:profileInfo.documents[0].ticket_id}}" class="f-14 cap_btn small">Go to Ticket</router-link>
        </div>
      </div>
    </div>
    <div class="row" v-if="profileInfo.documents.length">
      <div class="col-12 col-md-6 mb-4" v-for="item in profileInfo.documents">
        <div class="documentsList">
          <label class="medium mb-2">{{ item.document_name }}</label>
          <div
            class="viewDocuments d-flex align-items-center justify-content-between border"
          >
            <span class="d-flex align-items-center document-img-pdf">
              <!-- <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents"> -->
              <vue-pdf class="pdfimg"
                height="50px"
                v-if="
                  item.document
                    .split('.')
                    [item.document.split('.').length - 1].toLowerCase() == 'pdf'
                "
                :src="
                  $env_var.docsLink +
                  'user&id=' +
                  get_user.profile.user_id +
                  '&doc=' +
                  item.document
                "
              />
              <img
                height="50px"
                v-else
                :src="
                  $env_var.docsLink +
                  'user&id=' +
                  get_user.profile.user_id +
                  '&doc=' +
                  item.document
                "
              />
              <!-- <span class="f-14 themecolor medium ml-3">Submitted</span> -->
              <span class="text-success ml-1 f-12 pl-2" v-if="item.status == 2">Approved</span>
              <span class="text-danger ml-1 f-12 pl-2" v-else-if="item.status == 1">Declined</span>
              <span class="text-warning ml-1 f-12 pl-2" v-else>Pending</span>
            </span>
            <a
              :href="
                $env_var.docsLink +
                'user&id=' +
                get_user.profile.user_id +
                '&doc=' +
                item.document
              "
              target="_blank()"
              class="viewEye l-1"
              ><feather size="18" type="eye"></feather
            ></a>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Residential Address Line 1</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Address Proof</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Certification of Incorporation</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Memorandum Articles</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Business Address</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Proof of the Current Directors</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Passport</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
                <div class="documentsList">
                    <label class="medium mb-2">Additional Documents</label>
                    <div class="viewDocuments d-flex align-items-center justify-content-between border">
                        <span class="d-flex align-items-center">
                            <img src="../../../../../static/website/images/documentImage.png" alt="Documents" title="View Documents">
                            <span class="f-14 themecolor medium ml-3">Submitted</span>
                        </span>
                        <a href="javascript:void(0)" class="viewEye l-1"><feather size="18" type="eye"></feather></a>
                    </div>
                </div>
            </div> -->
    </div>
    <div class="row d-flex justify-content-center" v-else>
      <no-data></no-data>
    </div>
    <!-- <div class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4">
            <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            <a href="javascript:void(0)" class="cap_btn">Save</a>
        </div> -->
  </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
  name: "accountprofile",
  mixins: [registerStepsMixins],
  data() {
    return {
      localDocuments: [],
      finalDocuments: [],
      notification_msg: "",
      notification_type: "",
      // tab: '1',
      submitted: false,
      // editAddress: false,
      // editNumber: false,

      fname: "",
      mName: "",
      lname: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      country: "",
      area_code: "",
      acc_type: "",
      OrganizationType: {
        0: "Company",
        1: "Self Managed Super Fund",
        2: "Discretionary/Unit Trust",
        3: "Others",
      },
    };
  },
  components: {
    // editAddress,
    // editNumber
  },

  methods: {
    create_image(url, name) {
      var stx = this.stxx;
      var link = document.createElement("a");
      link.download = name;
      link.href = url;
      link.click();
    },
    ChangeTab(val) {
      this.tab = val;
      // this.editAddress = false
      // this.editNumber = false
      this.pageLoader = false;
    },
    Submit() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              f_name: _that.fname,
              m_name: _that.mName,
              l_name: _that.lname,
              dob: _that.dob,
              Address: _that.address,
              City: _that.city,
              State: _that.state,
              Country: _that.country,
              Areacode: _that.area_code,
              Acc_type: _that.acc_type,
            },
            localParams: {
              parameter: _that,
            },
          };
        }
      });
    },
    allLocalDocuments(){
      this.localDocuments = this.localDocuments.concat(this.profileInfo.documents)
      this.finalDocuments = this.localDocuments.reduce((items, index) => {
        if(index.status == 0 || index.status == 2){
          if(!items.some(obj => obj.document_type === index.document_type)) {
            items.push(index);
          }
        }
        return items;
      },[]);
    },
  },
  created() {
    this.pageName("Account Profile");
    if ("documents" in this.profileInfo) {
    } else {
      this._runGetProfileInfo({
        globalParams: {},
        localParams: {
          parameter: this,
        },
      });
    }
    this.allLocalDocuments()
  },
};
</script>
<style>
.documentsList label{color: var(--themecolor);text-transform: none;}
.document-img-pdf img {
    width: 150px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #ddd;
    padding: 5px;
    margin: 10px 0;
}
.document-img-pdf .pdfimg{ width: 150px; object-fit: cover;
    border: 1px solid #ddd;
    padding: 5px;
    margin: 10px 0;    overflow: hidden;
    height: 80px}
</style>


// WEBPACK FOOTER //
// src/components/website/settings/files/documents.vue